export default __webpack_public_path__ + "static/media/browser.7d69a9c1.svg";